import { Rect } from './../math';
import { QuadNode } from './QuadNode';
import { ITEMBOUNDSCHANGE, ITEMROTATE, ROTATED } from './../constants';
import { QuadRoot } from './QuadRoot';
export class ShapesQuadTree {
    constructor(diagram) {
        this.ROOT_SIZE = 1000;
        const boundsChangeHandler = this._boundsChange.bind(this);
        diagram.bind(ITEMBOUNDSCHANGE, boundsChangeHandler);
        diagram.bind(ITEMROTATE, boundsChangeHandler);
        this.initRoots();
    }
    initRoots() {
        this.rootMap = {};
        this.root = new QuadRoot();
    }
    clear() {
        this.initRoots();
    }
    _boundsChange(e) {
        if (e.item._quadNode) {
            e.item._quadNode.remove(e.item);
        }
        this.insert(e.item);
    }
    insert(shape) {
        const bounds = shape.bounds(ROTATED);
        const rootSize = this.ROOT_SIZE;
        const sectors = this.getSectors(bounds);
        const x = sectors[0][0];
        const y = sectors[1][0];
        if (this.inRoot(sectors)) {
            this.root.insert(shape, bounds);
        }
        else {
            if (!this.rootMap[x]) {
                this.rootMap[x] = {};
            }
            if (!this.rootMap[x][y]) {
                this.rootMap[x][y] = new QuadNode(new Rect(x * rootSize, y * rootSize, rootSize, rootSize));
            }
            this.rootMap[x][y].insert(shape, bounds);
        }
    }
    remove(shape) {
        if (shape._quadNode) {
            shape._quadNode.remove(shape);
        }
    }
    inRoot(sectors) {
        return sectors[0].length > 1 || sectors[1].length > 1;
    }
    getSectors(rect) {
        const rootSize = this.ROOT_SIZE;
        const bottomRight = rect.bottomRight();
        const bottomX = Math.floor(bottomRight.x / rootSize);
        const bottomY = Math.floor(bottomRight.y / rootSize);
        const sectors = [[], []];
        for (let x = Math.floor(rect.x / rootSize); x <= bottomX; x++) {
            sectors[0].push(x);
        }
        for (let y = Math.floor(rect.y / rootSize); y <= bottomY; y++) {
            sectors[1].push(y);
        }
        return sectors;
    }
    hitTestRect(rect, exclude) {
        const sectors = this.getSectors(rect);
        let xIdx, yIdx, x, y;
        let root;
        if (this.root.hitTestRect(rect, exclude)) {
            return true;
        }
        for (xIdx = 0; xIdx < sectors[0].length; xIdx++) {
            x = sectors[0][xIdx];
            for (yIdx = 0; yIdx < sectors[1].length; yIdx++) {
                y = sectors[1][yIdx];
                root = (this.rootMap[x] || {})[y];
                if (root && root.hitTestRect(rect, exclude)) {
                    return true;
                }
            }
        }
        return false;
    }
}
